import styled from "styled-components";

export const PersonaAccessReportStyled = styled.div`
  padding: 2rem;

  .report-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 2rem;
    background-color: #f9f9f9;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    width: 100%;
  }

  .report-header h2 {
    margin: 0;
    font-size: 1.5rem;
    color: #333;
    font-weight: 600;
  }

  .filter-group {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    align-items: center;
    width: 100%;
  }

  .filter-group .residential-dropdown,
  .filter-group .p-calendar {
    min-width: 200px;
    max-width: 300px;
    width: 100%;
  }

  .generate-button {
    align-self: flex-start;
    margin-top: 0.5rem;
  }

  .info-box {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1.5rem;
    padding: 1rem;
    background-color: #fafafa;
    border-left: 4px solid #4caf50;
    border-radius: 6px;
    font-size: 1rem;
    color: #333;
  }

  .info-box span {
    background-color: #fff;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .table-container {
    width: 100%;
  }

  .loading-message {
    text-align: center;
    padding: 2rem;
    font-size: 1.2rem;
    color: #666;
  }

  @media (min-width: 768px) {
    .filter-group {
      flex-direction: row;
    }

    .filter-group .residential-dropdown,
    .filter-group .p-calendar {
      width: auto;
    }

    .info-box {
      font-size: 1.1rem;
    }
  }
`;